/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Directive, HostListener, Input } from '@angular/core';
import { FeedbackService } from '@app/core/services';

@Directive({
    selector: '[clickToCopy]',
    standalone: true,
})
export class ClickToCopyDirective {
	@Input('clickToCopy') text = '';
	@Input() toastOnCopy = true;

	constructor(private readonly feedbackService: FeedbackService) {}

	@HostListener('click')
	async onClick() {
		if (!this.text) {
			return;
		}

		await navigator.clipboard.writeText(this.text);

		if (this.toastOnCopy) {
			this.feedbackService.customSuccess('Text copied to clipboard');
		}
	}
}
